export class LlmClientCapabilities {
  public thinking: boolean;
  public vision: boolean;
  public promptCaching: boolean;
  public batching: boolean;
  public functionCalling: boolean;
  public streaming: boolean;

  constructor(data: any = {}) {
    this.thinking = data.thinking || false;
    this.vision = data.vision || false;
    this.promptCaching = data.promptCaching || false;
    this.batching = data.batching || false;
    this.functionCalling =
      data.functionCalling !== undefined ? data.functionCalling : true; // Default true
    this.streaming = data.streaming !== undefined ? data.streaming : true; // Default true
  }
}
